// White-label branding for the app chrome. Override at build time via
// REACT_APP_* environment variables; defaults are neutral (no hardcoded
// CarDekho / Girnar branding). Tenant-facing support contact details come
// separately from the backend `GET /api/support/contact` endpoint.
const brandName = process.env.REACT_APP_BRAND_NAME || 'ConsentCMS';

export const BRANDING = {
  brandName,
  productName: process.env.REACT_APP_PRODUCT_NAME || 'Consent Management',
  brandInitial: (brandName.trim().charAt(0) || 'C').toUpperCase(),
  // Empty string hides the "Powered by …" footer line entirely.
  poweredBy: process.env.REACT_APP_POWERED_BY || '',
};
